const SESSION_KEY = 'adaChatSession';
const RESUME_WINDOW_MS = 15 * 60 * 1000;
const CLOSED = 'closed';
const OPEN = 'open';

let startedEmbed;
let subscribedEmbed;
let isPageHideListenerAdded = false;
let onChatClosedCallback;

const markOpenChatMinimizedOnPageHide = () => {
  try {
    if (window.sessionStorage.getItem(SESSION_KEY) === OPEN) {
      window.sessionStorage.setItem(SESSION_KEY, new Date());
    }
  } catch {
    return;
  }
};

export const markAdaChatDrawer = isOpen => {
  try {
    const storage = window.sessionStorage;
    if (!isOpen && storage.getItem(SESSION_KEY) === CLOSED) return;

    storage.setItem(SESSION_KEY, isOpen ? OPEN : new Date());

    if (isOpen && !isPageHideListenerAdded) {
      window.addEventListener('pagehide', markOpenChatMinimizedOnPageHide);
      isPageHideListenerAdded = true;
    }
  } catch {
    return;
  }
};

export const markAdaChatClosed = () => {
  try {
    window.sessionStorage.setItem(SESSION_KEY, CLOSED);
  } catch {
    return;
  }
};

export const stopAdaChat = async () => {
  if (!isAdaStarted()) return;

  startedEmbed = null;
  subscribedEmbed = null;
  await window.adaEmbed.stop();
};

const onAdaChatClosed = () => {
  markAdaChatClosed();
  onChatClosedCallback?.();
  stopAdaChat();
};

export const subscribeToAdaChatLifecycleEvents = async onChatClosed => {
  onChatClosedCallback = onChatClosed;
  const embed = window.adaEmbed;
  if (!embed || typeof embed.subscribeEvent !== 'function' || subscribedEmbed === embed) return;

  await Promise.all([
    embed.subscribeEvent('ada:close_chat', onAdaChatClosed),
    embed.subscribeEvent('ada:end_conversation', onAdaChatClosed),
  ]);
  subscribedEmbed = embed;
};

export const canResumeAdaChat = () => {
  try {
    const savedState = window.sessionStorage.getItem(SESSION_KEY);
    if (savedState === OPEN) return true;
    if (savedState === CLOSED) return false;
    if (!savedState) return false;

    const minimizedAt = Date.parse(savedState);
    const elapsed = Date.now() - minimizedAt;
    if (elapsed >= 0 && elapsed <= RESUME_WINDOW_MS) return true;

    window.sessionStorage.removeItem(SESSION_KEY);
  } catch {
    return false;
  }

  return false;
};

export const isAdaStarted = () => Boolean(window.adaEmbed && startedEmbed === window.adaEmbed);
export const setAdaStarted = () => {
  startedEmbed = window.adaEmbed;
};
